"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFocusStyles = void 0;
function getFocusStyles(theme) {
    return {
        '&:focus': {
            outline: 'none',
            boxShadow: "0 0 0 2px " + (theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.white) + ", 0 0 0 4px " + theme.colors[theme.primaryColor][5],
        },
        '&:focus:not(:focus-visible)': {
            boxShadow: 'none',
        },
    };
}
exports.getFocusStyles = getFocusStyles;
